<template>
	<div class="learner_program_data">
		<div class="row">
      <div class="col-12">
        <template v-if="isStreamStructureRendered">
	        <template v-if="selectedProgram.uuid">
	          <b-card class="text-center prog-lmi">
							<template #header>
								<div class="hd_ic">
									<img :src="selectedProgram.programThumbnail" />
								</div>
	        			<div class="hd_txt">
									<template v-if="learnerEnrollmentData.length > 1">
										<v-select :options="learnerEnrollmentData" :clearable="false" label="programTitle" v-model="selectedProgram" @input="renderSelectedProgram">
										  <template slot="option" slot-scope="option">
										    <img :src="option.programThumbnail" style="width: 40px; height: 40px" />
										    {{option.programTitle}}
										  </template>
										</v-select>
									</template>
									<template v-else>
										<v-clamp class="" autoresize :max-lines="2">{{selectedProgram.programTitle}}</v-clamp>
									</template>
								</div>
	      			</template>

							<template v-if="course.uuid">
								<div class="crd_content">
									<b-card-text>
			              <div class="row sec_row">
			                <div class="col-4 thumbnail_container">
			                	<div class="thumbnail" :style="{background: setThumbnailBgColor(course.uuid)}">
		                      <div class="txt">
		                        <div ref="courseThumbnail" v-html="setThumbnailTitle(course.title)"></div>
		                      </div>
		                    </div>
			                </div>
			                <div class="col-8 entity_title">{{course.title}}</div>
			              </div>
			            </b-card-text>
								</div>
								<div class="row">
									<div class="col-12" v-if="!transactionValidity.transactionValid">
										<div class="row alert_msg_sec">
											<div class="col-9 msg_container">
												<span v-html="getInstitutionPurchaseExpirationMessage(transactionValidity)"></span>
											</div>
											<div class="col-3 btn_container" v-if="!transactionValidity.programSwitched && !transactionValidity.inactive">
												<b-btn @click="navigateToSelectedProgram">Renew</b-btn>
											</div>
										</div>
									</div>
									<div class="col-12" v-if="transactionValidity.transactionValid && userObject.suspended">
										<div class="row alert_msg_sec">
											<div class="col-12 msg_container">
												<span v-html="institution.userSuspensionMessage">
												</span>
											</div>
										</div>
									</div>

									<div class="col-12" v-if="transactionValidity.transactionValid && !userObject.suspended">
										<div class="lnk_container row">
											<div class="col-6">

											</div>
											<div class="col-6" v-if="releaseStatus">
												<b-btn @click="continueLearning" :aria-label="$tf(buttonLabel)" size="sm">
													{{ $tf(buttonLabel) }}
												</b-btn>
											</div>
											<div class="col-6" v-if="!releaseStatus">
												<div class="lnk_container">
                          <b-link class="btn_lock_unlock" v-b-modal="'releaseModal_' + course.uuid">
														<span class="ic22-lock"></span>
													</b-link>
                				</div>
											</div>
										</div>
									</div>
								</div>
							</template>
							<template v-else>
			          <div class="crd_content">
			            <b-card-text>
			              <div class="mt-4">
			                <span v-if="isCourseCompleted">Congratulations, you have completed the course.</span>
			                <span v-else>Learning data not available.</span>
			              </div>
			            </b-card-text>
								</div>
			        </template>
	          </b-card>
	        </template>
	        <template v-else>
	          <b-card class="text-center prog-lmi">
							<template #header>
								<div class="hd_ic">
								</div>
								<div class="hd_txt">
								</div>
							</template>
							<div class="crd_content">
		            <b-card-text>
		              <div class="mt-5">
		                <span>Program Learning data not available.</span>
		              </div>
		            </b-card-text>
							</div>
	          </b-card>
	        </template>
        </template>
	      <template v-else>
	      	<b-card class="text-center prog-lmi">
						<template #header>
							<div class="hd_ic">
							</div>
        			<div class="hd_txt">
							</div>
      			</template>
		      	<div class="crd_content">
		      		<b-card-text>
	              <div class="text-center mt-5">
	              	<stretch></stretch>
	              </div>
	            </b-card-text>
						</div>
					</b-card>
	      </template>
      </div>
    </div>

		<div class="modal_popup_container course_unlock_modal">
			<b-modal ref="unlockCourseModal" class="description_modal" size="md" :id="'releaseModal_' + course.uuid" ok-only ok-title="ok">
				<div slot="modal-header" class="header-section">
					<div class="ic_container">
						<span class="ic ic22-lock"></span>
					</div>
					<div class="head_txt">Course is Locked</div>
					<div class="btn_container">
						<button type="button" class="btn_close" @click="hideUnlockCourseInfoModal" data-dismiss="modal" aria-label="Close">
							<span class="ic-close"></span>
						</button>
					</div>
				</div>

				<div class="row">
					<div class="col-12 txt_row">
						{{course.title}}
					</div>
					<div class="col-12 txt_row">
						<div v-html="releaseLogicDetail"></div>
					</div>
				</div>

			</b-modal>
		</div>

		<div class="modal_popup_container course_unlock_modal">
			<b-modal ref="ssoCourseModal" class="description_modal" size="md" :id="'ssoModal_' + course.uuid" hide-footer>
				<div slot="modal-header" class="header-section">
					<div class="head_txt">Reconfirm Credentials </div>
					<div class="btn_container">
						<button type="button" class="btn_close" @click="hideSsoCourseInfoModal" data-dismiss="modal" aria-label="Close">
							<span class="ic-close"></span>
						</button>
					</div>
				</div>

				<div class="row">
					<div class="col-12 txt_row mt-3">
						We need to reconfirm your credentials, before you can access the course.
					</div>
					<div class="col-12 txt_row btn_container mt-3" style="text-align: right;">
						<b-button class="btn mr-3" @click="redirectToSsoLogin">login to course</b-button>
					</div>
				</div>

			</b-modal>
		</div>

	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
	import {Stretch} from 'vue-loading-spinner'
	import VClamp from 'vue-clamp'
	import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

	export default {
		name: 'learner-program-course-learn',
		components: {
			VClamp,
			Stretch
		},
    props: ['program'],
    data: () => {
    	return {
    		course: {},
    		releaseStatus :true,
    		releaseLogicDetail: '',
    		buttonLabel: '',
    		selectedProgram: {},
    		competencySummaries: [],
    		isCourseCompleted: false,
        isStreamStructureRendered: false,
        userObject: JSON.parse(localStore.getItem('userobj')),
        transactionValidity: {transactionValid:true}
    	}
    },
    created () {
    	this.competencySummaries = []
    	_.forEach(this.learnerEnrollmentData, (data) => {
    		let programCode = data.programCode
    		this.populateStreamStructure(programCode)
    	})
    },
    beforeMount () {
    },
    mounted () {
    	this.$nextTick(() => {
    		this.$nextTick(() => {
	    		setTimeout(() => {
		    		this.renderCurrentProgramAndCourse()
		    	}, 2000)
		    	setTimeout(() => {
		    		this.chekComponenetLoaded(1)
		    	}, 4000)

	    	})
    	})
    },
    methods: {
			...mapActions([
        'loadStreamWithStructure',
        'loadStreamWithStructureSummary',
        'loadCompetencyProgress',
        'loadContinueLearningLast',
        'loadCheckTransactionValidity',
        'loadStreamLeafForCourse'
      ]),
      navigateToSelectedProgram () {
        let routerParams = {
          cipCode: this.selectedProgram.programCipCode,
          programGuideCode: this.selectedProgram.programCode,
          type: this.selectedProgram.programType,
          returnTo: 'learnerDashboard',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideIntroduction', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      },
      renderSelectedProgram (selectedProgram) {
      	let programCode = selectedProgram.programCode
      	this.renderCurrentProgramAndCourse(programCode)
      },
      getInstitutionPurchaseExpirationMessage(tr){
      let expiredProgramMessage = `<p class="p1" style="margin: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 13px; line-height: normal; font-family: 'Helvetica Neue';"><span style="font-size: 10pt;">Your access to this program has expired.<span class="Apple-converted-space">&nbsp;</span></span></p><p class="p1" style="margin: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 13px; line-height: normal; font-family: 'Helvetica Neue';"><span style="font-size: 10pt;">Don&rsquo;t worry - we have saved your progress!</span></p><p class="p1" style="margin: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 13px; line-height: normal; font-family: 'Helvetica Neue';"><span style="font-size: 10pt;">&nbsp;</span></p><p class="p1" style="margin: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 13px; line-height: normal; font-family: 'Helvetica Neue';"><span style="font-size: 10pt;">You can continue learning when you renew.</span></p>`;
        if(tr.institutionPurchaseExpirationMessage){
        	expiredProgramMessage = tr.institutionPurchaseExpirationMessage
        }
      	return expiredProgramMessage
      },
      populateCurrentCompetencySummary (competencySummaries, isNoActivity) {
      	let competencySummary = undefined
      	let sortedSummaries = _.orderBy(competencySummaries, ['status', 'lastUpdatedTime'], ['desc', 'desc'])
      	let filteredSummaries = _.filter(sortedSummaries, (summary) => {
    			return (summary.status !== 2)
    		})
    		if (filteredSummaries.length > 0) {
    			competencySummary = isNoActivity ? competencySummaries[0]:filteredSummaries[0]
    		} else {
      		competencySummary = sortedSummaries[0]
    		}
    		return competencySummary
      },
      chekComponenetLoaded (i){
      		if(!this.$refs.courseThumbnail && i<3){
      			this.renderCurrentProgramAndCourse()
	      		setTimeout(() => {
			    		this.chekComponenetLoaded(++i)
			    	}, 2000)
			    }

      },
      async renderCurrentProgramAndCourse (programCode) {
      	this.course = {}
      	this.releaseStatus = true
      	this.releaseLogicDetail = ''
      	this.selectedProgram = {}
        this.transactionValidity = {transactionValid:true}
      	this.isCourseCompleted = false
      	this.isStreamStructureRendered = false
      	let competencySummary = undefined
      	let isNoActivity = true
      	for (let i = 0; i < this.competencySummaries.length; i++) {
      		let summary = this.competencySummaries[i]
      		if (summary.status > 0) {
      			isNoActivity = false
      			break
      		}
      	}
      	if (programCode) {
      		let summaries = _.filter(this.competencySummaries, (summary) => {
      			return (programCode === summary.uuid.split('_')[0])
      		})
      		competencySummary = this.populateCurrentCompetencySummary(summaries, isNoActivity)
      	} else {
      		competencySummary = this.populateCurrentCompetencySummary(this.competencySummaries, isNoActivity)
      	}
      	this.isCourseCompleted = (competencySummary.status === 2)
				if (!this.isCourseCompleted) {
					this.course = {uuid: competencySummary.courseId, title: competencySummary.titleForStudent}
					// Check if Course is
					this.buttonLabel = (competencySummary.status === 0) ? 'startLearning' : 'continueLearning'
				} else {
						this.buttonLabel = 'View Course'
				}
        this.isStreamStructureRendered = true
        let key = competencySummary.uuid.split('_')[0]
        let selectedProgram = _.find(this.learnerEnrollmentData, (data) => {
          return (key === data.programCode)
        })
        let courseLeaf = await this.loadStreamLeafForCourse({programCode:selectedProgram.programCode, originUuid:competencySummary.courseId})
        this.releaseStatus = courseLeaf.releaseStatus
        this.releaseLogicDetail = courseLeaf.releaseLogicDetail

        this.$root.$emit('reloadCompetencyProgress', selectedProgram)
        this.selectedProgram = selectedProgram
        this.transactionValidity = await this.loadCheckTransactionValidity(this.selectedProgram.programCode)
      },
      async populateStreamStructure (programCode) {
      	let summaries = await this.loadStreamWithStructureSummary({programCode: programCode})
      	for (let i = 0; i < summaries.length; i++) {
      	    let competencySummary =  summaries[i]
      			competencySummary.uuid = programCode + '_' + competencySummary.uuid
      			this.competencySummaries.push(competencySummary)
      	}

/*        await this.loadStreamWithStructure({programCode: programCode})
        let structure = this.planningStream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0) {
            let childStructure = children[0].structure
            if (childStructure) {
              let children = JSON.parse(childStructure)
              let courses = _.filter(children, (child) => {
			          return (child.entityType === 'deliverycontext')
			        })
			        let sortedCourses = _.sortBy(courses, 'order')
			        for (let i = 0; i < sortedCourses.length; i++) {
			        	let course = sortedCourses[i]
			        	let courseId = course.originUuid
			        	let competencySummary = await this.loadCompetencyProgress({entityId: courseId, loadDataFromServer: true})
			        	competencySummary.uuid = programCode + '_' + competencySummary.uuid
			        	this.competencySummaries.push(competencySummary)
			        }
            }
          }
        }
*/
      },
			continueLearning () {
				this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        let courseId = this.course.uuid
        this.loadContinueLearningLast({uuid: courseId, loadDataFromServer: true}).then(options => {
          if (options && options.length > 0) {
            if (options[0].title === 'EXTRENAL_COURSE_LAUNCH' && options[0].type ==='SSOCOURSE' && !this.userObject.ssoLogin) {
            	this.$refs.ssoCourseModal.show()
            	return
            }else {
	            if (options[0].title === 'EXTRENAL_COURSE_LAUNCH') {
	              let _window = window.open(options[0].uri, '_blank')
	               setTimeout(() => {
	            			_window.location = options[1].uri
	          			}, 5000)
	              return
	            }
	            if (options[0].title !== 'COURSE_FINISHED') {
	              return this.$router.push({name: 'courseDashboard', params: {uuid: courseId, showLastActivity: true}})
	            }
	           }
          }
          return this.$router.push({name: 'courseDashboard', params: {uuid: courseId}})
        })
			},
			setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
			hideUnlockCourseInfoModal () {
				this.$refs.unlockCourseModal.hide()
			},
			hideSsoCourseInfoModal () {
				this.$refs.ssoCourseModal.hide()
			},
			redirectToSsoLogin (){
					let ssoPath = this.institution.path
					localStorage.clear()
					window.location.href = '/sso/'+ssoPath
			},
      setThumbnailTitle (title) {
        if ((title.indexOf('-') !== -1) && (title.indexOf('-') < 7)) {
          let splitted = title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return title.substring(0, 7)
      }
		},
		computed: {
      ...mapState({
        'planningStream': state => state.dashboard.planningStream,
        'institution': state => state.institution.institution,
        'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData
      })
    }
	}
</script>

<style scoped>
  .prog-lmi .card-header {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramCourseLearn.vue